import React from "react";

/**
 * ClosingMoment — the final quiet punctuation of the Rituals page.
 *
 * "Move through your life with intention." — sits in a spacious ivory /
 * sand vignette; no CTAs, no gradients, no motion. The point is to give
 * the eye a place to rest.
 */
export default function ClosingMoment() {
  return (
    <section
      className="relative rounded-3xl px-6 py-16 md:py-24 text-center overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, #FBF9F5 0%, #F6F1E8 60%, #E9E0D3 100%)",
        border: "1px solid #DCD3C7",
      }}
      data-testid="rituals-closing-moment"
    >
      <div
        aria-hidden
        className="absolute inset-x-0 bottom-0 h-24 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 100%, rgba(184,115,85,0.06), transparent 70%)",
        }}
      />
      <div className="relative max-w-xl mx-auto">
        <div
          className="mx-auto w-10 h-px"
          style={{ background: "#C56B3F" }}
          aria-hidden
        />
        <p
          className="mt-8 font-display italic text-3xl md:text-4xl lg:text-5xl leading-[1.15]"
          style={{ color: "#292725" }}
          data-testid="rituals-closing-line"
        >
          <span style={{ color: "#C56B3F", marginRight: "0.35em" }}>&ldquo;</span>
          Move through your life with intention.
          <span style={{ color: "#C56B3F", marginLeft: "0.35em" }}>&rdquo;</span>
        </p>
      </div>
    </section>
  );
}
